import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import useUiState, { uiStore } from 'packages/workspace/services/store/ui-store';

/**
 * Global Component to Show Feedback Messages (Success & Errors)
 */
const Feedback: React.FC = () => {
  const uiState = useUiState();

  return (
    <>
      {uiState.success_message && (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          open
          autoHideDuration={10000}
          onClose={() => uiStore.clearSuccessMessage()}
          // className="alert-success"
        >
          <Alert onClose={() => uiStore.clearSuccessMessage()} id="success_message" variant="filled" severity="success">
            {uiState.success_message}
          </Alert>
        </Snackbar>
      )}
      {uiState.error_message && (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          open
          autoHideDuration={10000}
          onClose={() => uiStore.clearErrorMessage()}
          // className="alert-error"
        >
          <Alert onClose={() => uiStore.clearErrorMessage()} id="error_message" variant="filled" severity="error">
            {uiState.error_message}
          </Alert>
        </Snackbar>
      )}
      {uiState.info_message && (
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open
          style={{ right: '70px', top: '8px' }}
          autoHideDuration={5000}
          onClose={() => uiStore.clearInfoMessage()}
          className="alert-info"
        >
          <Alert onClose={() => uiStore.clearInfoMessage()} id="info_message" variant="filled" severity="info">
            {uiState.info_message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default Feedback;
